import jwtDecode from 'jwt-decode';
import {pushAnalyticsEvent} from '../Analytics';
import {NEW_CYBERSOURCE_PAYMENT_FORM} from '../../../consts';

export function initMicroform(captureContext, translations) {
    const styles = {
        input: {
            'font-size': '16px',
            'font-family': 'helvetica, tahoma, calibri, sans-serif',
            color: '#8290A1',
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale'
        },
        ':focus': {color: '#2f4662'},
        '::placeholder': {
            color: '#8290A1'
        },
        ':disabled': {cursor: 'not-allowed'}
    };

    const {
        cybersource: {
            cardNumberPlaceholder,
            labels: {
                securityCode: securityCodeLabel
            }
        }
    } = translations;

    const flex = new window.Flex(captureContext);
    const microform = flex.microform({styles});

    const cardNumber = microform.createField('number', {placeholder: cardNumberPlaceholder});
    cardNumber.load('#cardNumber-container');

    const securityCode = microform.createField('securityCode', {placeholder: securityCodeLabel});
    securityCode.load('#securityCode-container');

    return microform;
}

export function pushAnalyticsValidationEvent(error) {
    if (error) {
        pushAnalyticsEvent({
            interactionName: 'form error',
            formName: NEW_CYBERSOURCE_PAYMENT_FORM,
            formField: error.formField,
            formMessage: error.formMessage
        });
    } else {
        pushAnalyticsEvent({
            interactionName: 'form tracking',
            formName: NEW_CYBERSOURCE_PAYMENT_FORM,
            formField: 'pay-button'
        });
    }
}

export function fetchBin(cardDetailsToken) {
    const decoded = jwtDecode(cardDetailsToken);
    const bin = decoded.data.number.slice(0, 6);

    return fetch(
        `${window.location.pathname}/bank-identification-number/${bin}`,
        {
            method: 'GET'
        }
    );
}

export function createToken({microform, cybersourceOptions}) {
    return new Promise((resolve, reject) =>
        microform.createToken(cybersourceOptions, (err, token) => {
            if (err !== null) {
                reject(err);
            } else {
                resolve(token);
            }
        }));
}
